import { useState } from 'react';

const useSwitch = (props) => {
  const [show, setShow] = useState(false);
  const [time, setTime] = useState(props && props.timeout !== undefined ? props.timeout : 2000);
  const [message, setMessage] = useState('');
  const timeCallback = () => {
    setShow(false);
  };

  const [type, setType] = useState(props && props.type !== undefined ? props.type : 'tip');
  const [title, setTitle] = useState('');
  const [iconType, setIcon] = useState('error');

  const closeDialog = () => {
    setShow(false);
  };

  const showSuccessTip = (msg) => {
    setShow(true);
    setIcon('success');
    setType('tip');
    if (msg) {
      setMessage(msg);
    }
  };

  const showErrorTip = (msg) => {
    setShow(true);
    setIcon('error');
    setType('tip');
    if (msg) {
      setMessage(msg);
    }
  };
  const showErrorTipAndDetails = (msg) => {
    setShow(true);
    setIcon('error');
    setType('confirm');
    if (msg) {
      setMessage(msg);
    }
  };
  const showSuccessTipAndDetails = (title, msg) => {
    setShow(true);
    setIcon('success');
    setType('confirm');
    if (msg) {
      setMessage(msg);
    }
    if (title) {
      setTitle(title);
    }
  };

  return {
    show,
    time,
    timeCallback,
    type,
    iconType,
    message,
    showSuccessTip,
    showErrorTip,
    showSuccessTipAndDetails,
    showErrorTipAndDetails,
    title,
    onClose: closeDialog,
    onSubmit: closeDialog,
    onCancel: closeDialog,
  };
};

export default useSwitch;
